import { gql } from '@edreamsodigeo/frontend-api-client';

export const GET_CABIN_BAGS_QUERY = gql`
  query AncillaryOptionsForCabinBags($bookingId: ID) @ignore_update {
    ancillaryOptions(bookingID: $bookingId, flow: ONLINE) {
      cabinBags {
        carrier
        debugInfo
        segment
        section
        priceBreakdown {
          fee {
            amount
            currency
          }
          primeFee {
            amount
            currency
          }
          totalPrice {
            amount
            currency
          }
          totalPrimePrice {
            amount
            currency
          }
        }
        prices {
          type
          price {
            amount {
              amount
              currency
            }
            breakdown {
              items {
                concept
                price {
                  amount {
                    amount
                    currency
                  }
                  breakdown {
                    items {
                      concept
                      price {
                        amount {
                          amount
                          currency
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        carrierConfiguration {
          name
          smallBagSize
          cabinBagSize
          cabinBagWeight
          penaltyFee {
            amount
            currency
          }
          priorityBoardingIncluded
          cabinBagType
        }
      }
    }
  }
`;
